import {Component, inject} from '@angular/core';
import {ButtonSize, ButtonState, ButtonType} from '../../../../../../assets/types/dtoTypes';
import {RegistrationPageService} from '../../registration-page.service';
import {AzureService} from '../../../../../shared/services/azure.service';
import {TranslateModule} from "@ngx-translate/core";
import {UploadImageComponent} from "../../../../../shared/upload-image/upload-image.component";
import {BannerComponent} from "../../../../../shared/banner/banner.component";
import {ButtonComponent} from "../../../../../shared/button/button.component";

@Component({
  selector: 'app-bio-form',
  templateUrl: './bio-form.component.html',
  styleUrl: './bio-form.component.scss',
  imports: [
    TranslateModule,
    UploadImageComponent,
    BannerComponent,
    ButtonComponent
  ],
  standalone: true
})
export class BioFormComponent  {
  private registrationPageService = inject(RegistrationPageService);
  private azureService = inject(AzureService);

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonState = ButtonState;

  protected readonly ButtonType = ButtonType;

  id: string;

  bio: string;

  imageSet: boolean = false;

  constructor() {
    this.id = inject<string>('formData' as any);
  }

  continue() {
    this.registrationPageService.sendBio( this.bio );
    this.registrationPageService.openForm( 'bio_form_continue' );
  }

  setImageFile( file: File ) {
    this.azureService.updateProfileImage( this.id, file ).subscribe( ( user ) => {
      this.imageSet = true;
      this.bio = user.profileImageUrl;
    } );
  }

  isValid() {
    return this.bio && this.imageSet;
  }
}
